// src/ErrorBoundary.tsx
import { Component } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var ErrorBoundary = class extends Component {
  constructor() {
    super(...arguments);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, errorInfo) {
    console.error("Uncaught render error:", error, errorInfo);
  }
  render() {
    if (this.state.hasError) {
      return /* @__PURE__ */ jsxs(
        "div",
        {
          style: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "50vh",
            textAlign: "center",
            padding: 24,
            fontFamily: "sans-serif"
          },
          children: [
            /* @__PURE__ */ jsx("p", { style: { marginBottom: 16 }, children: "Something went wrong. Please refresh the page." }),
            /* @__PURE__ */ jsx("button", { onClick: () => window.location.reload(), children: "Reload" })
          ]
        }
      );
    }
    return this.props.children;
  }
};
export {
  ErrorBoundary
};
